import * as colors from 'shared/styles/colors';

export const defaultTheme = {
  statusMessageColor: colors.yellow40,
};
